<template>
    <div class="collapsible-option" :class="optionCssClasses">
        <div class="header item" :class="headerCssClasses" @click="select">
            <div class="icon" @click.stop="toggle"></div>
            <template v-if="selectable">
                <div class="title">
                    <Checkbox tag-name="div"
                              class="checkbox"
                              :value="value"
                              :checked="checked"
                              :disabled="value.disabled"/>
                    {{ value.title }}
                </div>
                <button class="add-synonym no-border iconed primary"
                        @click.stop="$emit('addSynonym', value.item)">
                    <span class="text">Добавить синоним</span>
                    <IconArrowLeft class="arr-icon"/>
                </button>
            </template>
            <template v-else>
                <slot :item="value.item"
                      :title="value.title"
                      :disabled="value.disabled"
                >
                    <div class="title">
                        {{ value.title }}
                    </div>
                </slot>
            </template>
        </div>
        <div class="nested">
            <Node v-for="it in value.nested"
                  v-show="it.visible"
                  :key="it.key"
                  :value="it"
                  :level="level + 1"
                  :selectedMap="selectedMap"
                  :selectableGroups="selectableGroups"
                  :flatGroups="flatGroups"
                  @selected="$emit('selected', $event)"
                  @addSynonym="$emit('addSynonym', $event)">
            </Node>
        </div>
    </div>
</template>

<script>
import NodeVectorMixin from '@/common/comp/selects/node.vector.mixin.js';

export default {
    name: 'Node',
    mixins: [ NodeVectorMixin ],
    data() {
        return {
            collapsed: false,
        };
    },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins.scss';

.collapsible-option {
    cursor: pointer;

    .item {
        display: flex;
        padding: 8px 12px;

        &:hover {
            background: var(--option-hover-background);
        }

        &.active {
            background: var(--option-active-background);
        }

        &.disabled {
            color: var(--input-disabled-color);
        }

        .title {
            display: flex;
            flex: auto;
            align-items: center;

            .checkbox {
                margin-right: 8px;
            }
        }

        .add-synonym {
            display: none;

            .arr-icon {
                transform: rotate(180deg);
            }
        }

        &:hover .add-synonym {
            display: inherit;
        }
    }

    .header > .icon {
        @include icon(16px, 16px);
        background-image: url(./icons/chevron_right.svg);
        transform: rotate(90deg);
        align-self: center;
        margin-right: 8px;
        opacity: 0.5;
    }

    .header .checkbox {
        display: flex;
    }

    &.flat {
        & > .header .icon {
            display: none;
        }

        &.hasnested {
            & > .header {
                background: var(--input-disabled-background);
                color: var(--input-disabled-color);
                font-size: 12px;
            }
        }

        &:not(.hasnested) {
            & > .nested {
                display: none;
            }
        }
    }

    &:not(.flat) {
        &.hasnested {
            & > .header {
                background: var(--input-disabled-background);
                color: var(--input-disabled-color);
                font-size: 12px;

                &:hover {
                    background: var(--option-hover-background);
                }
            }
        }

        &:not(.hasnested) {
            & > .header .icon {
                display: none;
            }

            & > .nested {
                display: none;
            }
        }

        &.collapsed {
            & > .header .icon {
                transform: rotate(0);
            }

            & > .nested {
                display: none;
            }
        }

        @for $level from 1 to 10 {
            &.level-#{$level} {
                & > .header {
                    padding-left: 12px + (24px * ($level - 1 ));
                }
            }
        }
    }
}
</style>
